import React from "react";
import {Outlet} from "react-router-dom";
import Header from "../components/header/Header";
import {LayoutContainer, LayoutGrid} from "./Layout.css";
import Footer from "../components/footer/Footer";

function Layout() {
    return (
        <div className={LayoutContainer}>
            <div className={LayoutGrid}>
                <Outlet/>
                <Header/>
            </div>
            <Footer/>
        </div>

    );
}

export default Layout;